import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor, RootContext } from '@skylab-angular-shared/core';
import { CurrencyCollectionQuery, CurrencyItem } from '@skylab-shared/business';
import { HttpService, Query, QueryHandler, RootContextBase, TaggedUrl, Tags } from '@skylab-shared/core';
import { KsefDocumentStatus, SaleDocumentKind } from '@skylab-shared/dataModel';
import { MS_PER_MINUTE } from '@skylab-shared/utils';

export interface SaleCheckCollectiveIdentifierQueryParams {
    collectiveIdentifier: string;
}

export type SaleCheckCollectiveIdentifierItem = {
    dueDate: Date;
    documentNumber: string;
    grossValue: number;
    ksefDocumentStatus: KsefDocumentStatus;
    version: string;
    leftToPay: number;
    id: number;
    currency: CurrencyItem;
    kind: SaleDocumentKind;
    ksefNumber: string;
    sellerName: string;
    finalAdvance?: boolean;
    advanceValue?: number;
};

export type SaleCheckCollectiveIdentifierInternalItem = {
    dueDate: Date;
    documentNumber: string;
    grossValue: number;
    ksefDocumentStatus: KsefDocumentStatus;
    version: string;
    leftToPay: number;
    id: number;
    currencyId: number;
    kind: SaleDocumentKind;
    finalAdvance?: boolean;
    advanceValue?: number;
    ksefNumber: string;
    sellerName: string;
};

export class SaleCheckCollectiveIdentifierQuery extends Query<SaleCheckCollectiveIdentifierItem[]> {
    public constructor(public readonly params: SaleCheckCollectiveIdentifierQueryParams) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleCheckCollectiveIdentifierQuery)
export class SaleCheckCollectiveIdentifierQueryHandler implements QueryHandler<SaleCheckCollectiveIdentifierQuery> {
    #url = TaggedUrl.join('eInvoices/collective-identifier', [Tags.Api]);
    #http = inject(Http) as HttpService;
    #rootContext = inject(RootContext) as any as RootContextBase;

    public async handleAsync({ params }: SaleCheckCollectiveIdentifierQuery): Promise<SaleCheckCollectiveIdentifierItem[]> {
        const { data } = await this.#http.get<SaleCheckCollectiveIdentifierInternalItem[]>(this.#url, { params: { collectiveIdentifier: params?.collectiveIdentifier }, timeout: 3 * MS_PER_MINUTE });

        const items = await Promise.all(data.map<Promise<SaleCheckCollectiveIdentifierItem>>(async item => {
            const currency = await this.#rootContext.firstAsync(CurrencyCollectionQuery, { id: item.currencyId });
            return {
                ...item,
                currency
            }
        }));
        return items;
    }
}
